import { Box, buildPath, buildTemplatePath, Page, PageRoute, Stack, Typography } from "@compass/core";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

const routeName = "404";

export const the404PageRoute: PageRoute = {
  handle: "404",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const The404Page = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100vh">
      <SentimentVeryDissatisfiedIcon sx={{ fontSize: "200px" }} color="error" />
      <Typography variant="h1" color="error">
        404
      </Typography>
      <Typography variant="h4" mt={10} align="center">
        The content you've requested was not found or it has expired.
      </Typography>
    </Stack>
  );
};
